/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Helpcentre_Faqs_Title1Inputs */

const en_helpcentre_faqs_title1 = /** @type {(inputs: Helpcentre_Faqs_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQs`)
};

/**
* | output |
* | --- |
* | "FAQs" |
*
* @param {Helpcentre_Faqs_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const helpcentre_faqs_title1 = /** @type {((inputs?: Helpcentre_Faqs_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Helpcentre_Faqs_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_helpcentre_faqs_title1(inputs)
});
export { helpcentre_faqs_title1 as "helpCentre_faqs_title" }